import React, { useState, useEffect } from 'react'
import { useForm, Controller } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import { Panel, Form, Message } from 'rsuite'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import ProposalReviseForm from '../../components/forms/proposalReviseForm/ProposalReviseForm'
import pathname from '../../constants/pathname'
import { useParams, useHistory } from 'react-router-dom'
import { startLoading, doneLoading } from '../../utils/loading'
import { saveChangeAgreement } from '../../redux/actions/contract'
import { getSchemaSidebar } from '../../redux/actions/sidebar'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'

export default function ReviseContractStaff({ onSuccess, ...props }) {
  const { register, handleSubmit, errors, control, setValue, setError, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(props.schema)
  const [isLoading, setIsLoading] = useState()
  const [isError, setIsError] = useState()
  const [successMessage, setSuccessMessage] = useState('')

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  // const projectId = '9BE3B891-FD65-416B-8459-7AD624B5D3F2'
  let history = useHistory()
  const dispatch = useDispatch()

  const handleCallService = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    setSuccessMessage('')
    try {
      const response = await saveChangeAgreement(request, projectId)
      console.log('response', response)
      if (response.success) {
        // setFormSchema(response.model)
        // await dispatch(getSchemaSidebar(response.model?.newProjectVersionId || projectId))
        // setSuccessMessage('ทำรายการสำเร็จ โปรดดำเนินการแก้ไขหัวข้อที่ท่านเลือก')
        // onSuccess(response.model)
        //const _url = window.location.href
        setTimeout(() => {
          sessionStorage.setItem('projectId', response.model.newProjectVersionId)
          sessionStorage.setItem('param', '')

          doneLoading()
          setIsLoading(false)

          location.reload()
          // window.location.href = _url.replace(projectId, response.model.newProjectVersionId)
          //window.location.href = _url
        }, 1000)
      }

      //return history.push(`${pathname.proposal.overview.overviewCoworker}/${projectId}`)
    } catch (e) {
      console.log('e', e)
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('ReviseContractStaff onSubmit', data)

    const request = {
      projectVersionId: projectId,
      revises: [
        {
          subItems: data.requestBody,
        },
      ],
    }
    //console.log('request', request)

    handleCallService(request)
  }

  return (
    <>
      <Form fluid>
        {isLoading && <OverlayLoader />}

        <Panel shaded header="" bordered collapsible defaultExpanded>
          <ProposalReviseForm
            schema={formSchema.revises}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
          />
          <hr />
          {isError && (
            <div style={{ marginTop: 10, marginBottom: 10 }}>
              <Message showIcon type="error" description={`บันทึกเพื่อแก้ไขไม่สำเร็จ`} />
            </div>
          )}
          {successMessage && (
            <div style={{ marginTop: 10, marginBottom: 10 }}>
              <Message showIcon type="success" description={successMessage} />
            </div>
          )}
          <SaveButton onClick={handleSubmit(onSubmit)} disabled={isLoading}>
            บันทึกเพื่อแก้ไข
          </SaveButton>
        </Panel>
        <br />
      </Form>
    </>
  )
}
